const VALUE_MISSING = "Select an option to continue.";
const STRINGS = {
  openMenu: "Open menu",
  selectedText: ", selected",
  selectAllText: "Select All",
  itemCountText: count => `Selected (${count})`,
  nativeValidationMessages: {
    valueMissing: VALUE_MISSING
  },
  listLabel: label => `${label} options, multiple selections available.`,
  groupAriaLabel: (label, selected) => `Select All ${label} Group Header${selected ? ", selected" : ""}`,
  requiredErrorMessage: VALUE_MISSING
};
export default STRINGS;